import { render, staticRenderFns } from "./ViewTitle.vue?vue&type=template&id=4a5099ee&scoped=true&"
import script from "./ViewTitle.vue?vue&type=script&lang=js&"
export * from "./ViewTitle.vue?vue&type=script&lang=js&"
import style0 from "./ViewTitle.vue?vue&type=style&index=0&id=4a5099ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5099ee",
  null
  
)

export default component.exports